import React from "react";
import HomeIcon from "@mui/icons-material/Home";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import HistoryIcon from "@mui/icons-material/History";
import BadgeIcon from "@mui/icons-material/Badge";
import { CardGiftcard } from "@mui/icons-material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import PolicyIcon from "@mui/icons-material/Policy";
import GroupsIcon from "@mui/icons-material/Groups";
import LaptopWindowsIcon from "@mui/icons-material/LaptopWindows";

export const sidebarLinks = [
  {
    id: 1,
    name: "Dashboard",
    path: "/dashboard",
    icon: <HomeIcon />,
    roles: ["TenantUser", "TenantAdmin"],
  },
  {
    id: 2,
    name: "User",
    path: null,
    icon: <AccountCircleOutlinedIcon />,
    roles: ["TenantAdmin"],
    subMenu: [
      {
        id: 1,
        name: "Create Multiple Users",
        path: "/createmultipleusers",
        icon: null,
        roles: ["TenantAdmin"],
      },
      {
        id: 2,
        name: "Create User",
        path: "/createuser",
        icon: null,
        roles: ["TenantAdmin"],
      },
      {
        id: 3,
        name: "All Users",
        path: "/AllUser",
        icon: null,
        roles: ["TenantAdmin"],
      },
    ],
  },
  {
    id: 3,
    name: "Policy Management",
    path: null,
    icon: <PolicyIcon />,
    roles: ["TenantAdmin"],
    subMenu: [
      {
        id: 1,
        name: "Create Policy",
        path: "/createpolicy",
        icon: null,
        roles: ["TenantAdmin"],
      },
      {
        id: 2,
        name: "All Policies",
        path: "/allPolicies",
        icon: null,
        roles: ["TenantAdmin"],
      },
      {
        id: 3,
        name: "Attach Policy",
        path: "/attachPolicy",
        icon: null,
        roles: ["TenantAdmin"],
      },
      {
        id: 4,
        name: "All Attached Policies",
        path: "/allAttachedPolicies",
        icon: null,
        roles: ["TenantAdmin"],
      },
    ],
  },
  {
    id: 4,
    name: "User Groups",
    path: null,
    icon: <GroupsIcon />,
    roles: ["TenantAdmin"],
    subMenu: [
      {
        id: 1,
        name: "Create User Group",
        path: "/createUserGroup",
        icon: null,
        roles: ["TenantAdmin"],
      },
      {
        id: 2,
        name: "All User Groups",
        path: "/allUserGroups",
        icon: null,
        roles: ["TenantAdmin"],
      },
    ],
  },
  {
    id: 5,
    name: "Credits & Transactions",
    path: null,
    icon: <CreditScoreIcon />,
    roles: ["TenantAdmin"],
    condition: (cookies) => cookies.get("isTenantLogin") === "false",
    subMenu: [
      {
        id: 1,
        name: "Transactions",
        path: "/Transactions",
        icon: null,
        roles: ["TenantAdmin"],
      },
      {
        id: 2,
        name: "Generate Coupon",
        path: "/generateCoupon",
        icon: null,
        roles: ["TenantAdmin"],
      },
      {
        id: 3,
        name: "Coupon List",
        path: "/couponList",
        icon: null,
        roles: ["TenantAdmin"],
      },
    ],
  },
  {
    id: 6,
    name: "Credits and Transactions",
    path: null,
    icon: <CreditScoreIcon />,
    roles: ["TenantUser", "TenantAdmin"],
    condition: (cookies) =>
      (cookies.get("userRole") === "TenantUser" &&
        cookies.get("isTenantLogin") === "false") ||
      (cookies.get("userRole") === "TenantAdmin" &&
        cookies.get("isTenantLogin") === "true"),
    subMenu: [
      {
        id: 1,
        name: "Credits",
        path: "/myCredit",
        icon: null,
        roles: ["TenantUser", "TenantAdmin"],
      },
      {
        id: 2,
        name: "Transactions",
        path: "/Transactions",
        icon: null,
        roles: ["TenantUser", "TenantAdmin"],
      },
    ],
  },
  {
    id: 7,
    name: "Lab Provision",
    path: null,
    icon: <HistoryIcon />,
    roles: ["TenantUser", "TenantAdmin"],
    subMenu: [
      {
        id: 1,
        name: "Lab Provision History",
        path: "/labProvisionHistory",
        icon: null,
        roles: ["TenantUser", "TenantAdmin"],
      },
    ],
  },
  {
    id: 8,
    name: "Monitoring",
    path: null,
    icon: <LaptopWindowsIcon />,
    roles: ["TenantAdmin"],
    condition: (cookies) => cookies.get("isTenantLogin") === "true",
    subMenu: [
      {
        id: 1,
        name: "Live User List",
        path: "/monitoring/live-user-list",
        icon: null,
        roles: ["TenantAdmin"],
      },
    ],
  },
  {
    id: 9,
    name: "Lab Access",
    path: null,
    icon: <BadgeIcon />,
    roles: ["TenantUser", "TenantAdmin"],
    subMenu: [
      {
        id: 1,
        name: "My Groups",
        path: "/myGroups",
        icon: null,
        roles: ["TenantUser"],
      },
      {
        id: 2,
        name: "My Attached Policies",
        path: "/myAttachedPolicies",
        icon: null,
        roles: ["TenantUser"],
      },
      {
        id: 3,
        name: "User Groups",
        path: "/userGroups",
        icon: null,
        roles: ["TenantAdmin"],
      },
    ],
  },
  {
    id: 10,
    name: "Grading History",
    path: null,
    icon: <HistoryIcon />,
    roles: ["TenantUser", "TenantAdmin"],
    subMenu: [
      {
        id: 1,
        name: "History",
        path: "/gradingHistory",
        icon: null,
        roles: ["TenantUser", "TenantAdmin"],
      },
    ],
  },
  {
    id: 11,
    name: "Certificates",
    path: "/certificate",
    icon: <CardGiftcard />,
    roles: ["TenantUser"],
  },
  {
    id: 12,
    name: "Certificate Settings",
    path: null,
    icon: <CardGiftcard />,
    roles: ["TenantAdmin"],
    subMenu: [
        {
            id: 1,
            name: "Certificate List",
            path: "/certificateList",
            icon: null,
            roles: ["TenantAdmin"],
        },
        {
          id: 2,
          name: "Theme Settings",
          path: "/certificateThemeSettings",
          icon: null,
          roles: ["TenantAdmin"],
        }
    ]
  }
];
  